import React, { useEffect, useState } from "react";
import * as cls from "./signIn.module.scss";
import { useDispatch, useSelector } from "react-redux";
import authImg from "../../resources/images/authorization.png";
import { useNavigate } from "react-router-dom";
import {
  assignAction,
  changeStepAction,
  resetStore,
  setInvalidLoginAction,
  setTokenAction,
} from "../../redux/actions/actions";
import { AuthorizationService } from "../authorizationService";
import { FooterView, Icon } from "../../../personal-studio-components/frame";
import { Button } from "../../../personal-studio-components/form";
import PolicyFooter from "../policyFooter/PolicyFooter";

export default function SignIn({
  setCurrpage,
  setStep,
  signUpVideoGuide,
  paramsLogin,
  paramsPassword,
}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberUser, setRememberUser] = useState(false);
  const isValidLoginPassword = useSelector(
    (state) => state.isValidLogin.isValidLogin,
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const messageError = useSelector((state) => state.isValidLogin.messageError);
  const [isEmptyField, setIsEmptyField] = useState(false);
  const [paswdVisible, setPaswdVisible] = useState(false);
  const onKeyUp = (event) => {
    if (event.code === "NumpadEnter" || event.code === "Enter") {
      handleSignIn(email, password);
    }
  };
  function successed(data) {
    dispatch(resetStore());
    dispatch(
      setInvalidLoginAction({
        isValidLogin: true,
        messageError: "",
      }),
    );
    dispatch(setTokenAction(data));
    if (rememberUser) {
      localStorage.setItem(
        "personalStudioAccessToken",
        JSON.stringify(data.access_token),
      );
      localStorage.setItem(
        "personalStudioRefreshToken",
        JSON.stringify(data.refresh_token),
      );
    } else {
      localStorage.setItem(
        "personalStudioAccessToken",
        JSON.stringify(data.access_token),
      );
      localStorage.setItem(
        "personalStudioRefreshToken",
        JSON.stringify(data.refresh_token),
      );
    }
    navigate("/");
  }
  function failed(data) {
    const err = data;
    const errorEvent = new ErrorEvent("error", {
      error: err,
    });
    window.dispatchEvent(errorEvent);
    if (err.error_type === "unassigned") {
      dispatch(assignAction({ email, password }));
      setCurrpage("assign");
    }
  }

  const handleSignIn = async (email, password) => {
    if (!email || !password) {
      setIsEmptyField(true);
      return;
    }
    const request = {
      method: "post",
      path: "/login",
      data: {
        email,
        password,
      },
    };
    const data = await AuthorizationService.send(request, (response) => {});

    if (data.errors) {
      failed(data);
    }
    if (data.access_token) {
      successed(data);
    }
  };

  useEffect(() => {
    if (email && password) {
      setIsEmptyField(false);
    }
  }, [email, password]);
  useEffect(() => {
    if (paramsLogin && paramsPassword) {
      setEmail(paramsLogin);
      setPassword(paramsPassword);
      handleSignIn(paramsLogin, paramsPassword);
    }
  }, [paramsLogin, paramsPassword]);

  if (!paramsLogin)
    return (
      <div className={cls.root}>
        <div className={cls.imgContainer}>
          <img src={authImg} />
        </div>
        <div className={cls.logWrapper}>
          <div className={cls.logContainer} onKeyUp={onKeyUp}>
            <div className={cls.header}>Вход</div>
            <div className={cls.body}>
              <div className={cls.login}>
                <span className={cls.gray_text}>Логин</span>
                <input
                  autoFocus
                  autoComplete="off"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="Введите свой логин"
                />
              </div>
              <div className={cls.password}>
                <span className={cls.gray_text}>Пароль</span>
                <input
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  type={paswdVisible ? "" : "password"}
                  placeholder="Введите свой пароль"
                />
                <div
                  className={cls.password_control}
                  onClick={() => setPaswdVisible((prev) => !prev)}
                >
                  <Icon
                    name={paswdVisible ? "eye_invisible" : "eye_visible"}
                    className={cls.icon}
                  />
                </div>
              </div>
            </div>
            <div className={cls.someContainer}>
              <div className={cls.rememberMe}>
                <input
                  type="checkbox"
                  checked={rememberUser}
                  onChange={(e) => {
                    setRememberUser(e.target.checked);
                  }}
                />
                <label>Запомнить меня</label>
              </div>
              <div>
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setCurrpage("restore");
                    // setStep(0);
                    dispatch(changeStepAction(0));
                  }}
                >
                  Забыли пароль
                </a>
              </div>
            </div>

            <span className={cls.invalid_login}>
              {isValidLoginPassword === false
                ? messageError
                : isEmptyField && "Заполните все поля"}
            </span>
            <div className={cls.btnContainer}>
              {/* <div className={cls.signPrimary}>
                <button onClick={() => handleSignIn(email, password)}>
                  Войти
                </button>
              </div> */}

              <Button
                type="primary"
                onClick={() => handleSignIn(email, password)}
              >
                Войти
              </Button>
              <Button type="default" onClick={() => setCurrpage("signUp")}>
                Зарегистрироваться
              </Button>

              {/* <div className={cls.signSecondary}>
                <button onClick={() => setCurrpage("signUp")}>
                  Зарегистрироваться
                </button>
              </div> */}
            </div>
            <div style={{ marginTop: "15px", textAlign: "center" }}>
              <a
                href={signUpVideoGuide}
                target="_blank"
                rel="noopener noreferrer"
              >
                Видеоинструкция по регистрации в Личном кабинете обучающегося
              </a>
            </div>
          </div>
          <div className={cls.policyFooter}>
            <PolicyFooter />
          </div>
        </div>
        <br />
      </div>
    );
}
